import React from 'react'
import PropTypes from 'prop-types'
import { Message } from 'semantic-ui-react'

const ErrorSSO = ({ message }) => {
  if (message === 'sso_config') {
    return (
      <Message warning>
        <Message.Header>There was a problem logging in with SSO</Message.Header>
        <p>
          SSO may not be available or configured for this account. To learn more about the
          requirements for using SSO in Simplesat,{' '}
          <a
            href="https://help.simplesat.io/en/articles/8340321-enterprise-sso-single-sign-on"
            target="_blank"
            rel="noreferrer"
          >
            visit our Help Center.
          </a>
        </p>
      </Message>
    )
  }

  return (
    <Message negative>
      <p>{message}</p>
    </Message>
  )
}

ErrorSSO.propTypes = {
  message: PropTypes.string,
}

export default ErrorSSO



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/LoginSSO/ErrorSSO/index.js